var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M5.75 2.42432H10.25C10.3875 2.42432 10.5 2.53682 10.5 2.67432V3.92432H5.5V2.67432C5.5 2.53682 5.6125 2.42432 5.75 2.42432ZM4 2.67432V3.92432H2C0.896875 3.92432 0 4.82119 0 5.92432V8.92432H6H10H16V5.92432C16 4.82119 15.1031 3.92432 14 3.92432H12V2.67432C12 1.70869 11.2156 0.924316 10.25 0.924316H5.75C4.78438 0.924316 4 1.70869 4 2.67432ZM16 9.92432H10V10.9243C10 11.4774 9.55313 11.9243 9 11.9243H7C6.44688 11.9243 6 11.4774 6 10.9243V9.92432H0V13.9243C0 15.0274 0.896875 15.9243 2 15.9243H14C15.1031 15.9243 16 15.0274 16 13.9243V9.92432Z",
          fill: "black",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }